import { Friendship, FriendshipWithUser } from '../../domain/models';
import { FriendshipRepository } from '../../domain/repositories';
import { FriendshipDataSource } from '../datasources/FriendshipDataSource';
import { friendshipEntityToModel, friendshipWithUserEntityToModel } from '../entities';

export class FriendshipRepositoryImpl implements FriendshipRepository {
  constructor(private dataSource: FriendshipDataSource) {}

  async sendRequest(requesterId: string, addresseeId: string): Promise<Friendship> {
    const entity = await this.dataSource.create(requesterId, addresseeId);
    return friendshipEntityToModel(entity);
  }

  async acceptRequest(friendshipId: string): Promise<Friendship> {
    const entity = await this.dataSource.update(friendshipId, 'accepted');
    return friendshipEntityToModel(entity);
  }

  async declineRequest(friendshipId: string): Promise<Friendship> {
    const entity = await this.dataSource.update(friendshipId, 'declined');
    return friendshipEntityToModel(entity);
  }

  async removeFriend(friendshipId: string): Promise<void> {
    await this.dataSource.delete(friendshipId);
  }

  async getFriends(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<FriendshipWithUser[]> {
    const entities = await this.dataSource.getFriends(userId, limit, offset);
    return entities.map(friendshipWithUserEntityToModel);
  }

  async getPendingRequests(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<FriendshipWithUser[]> {
    const entities = await this.dataSource.getPendingRequests(userId, limit, offset);
    return entities.map(friendshipWithUserEntityToModel);
  }

  async areFriends(userId1: string, userId2: string): Promise<boolean> {
    return await this.dataSource.areFriends(userId1, userId2);
  }

  async getPendingRequestBetween(
    userId1: string,
    userId2: string
  ): Promise<Friendship | null> {
    const entity = await this.dataSource.getPendingRequestBetween(userId1, userId2);
    if (!entity) return null;
    return friendshipEntityToModel(entity);
  }
}
